<template>
  <v-card
    border
    class="pa-4"
  >
    <p class="pb-0 mb-0 text-subtitle-2">
      {{ t('lead-timeline.filters.title') }}
    </p>
    <v-chip
      v-for="(filter, index) of filtersArray"
      :key="index"
      :variant="!filters[filter].isActive ? 'outlined' : 'flat'"
      class="ma-2"
      color="primary"
      rounded
      @click="() => toggleFilter(filter)"
    >
      <span :class="[filters[filter].isActive && 'text-white']">
        {{ t(ReadableTimelineFilters[filter]) }}
      </span>
    </v-chip>
  </v-card>
</template>
<script setup lang="ts">
import { inject, ref } from 'vue'
import { useI18n } from 'vue-i18n'

import type { TrackingPlugin } from '@/plugins/tracking'

import { ReadableTimelineFilters, TIMELINE_FILTERS } from './helpers/filters.js'

const $tracking = inject<TrackingPlugin>('tracking')
const { t } = useI18n()

const filters = ref({
  [TIMELINE_FILTERS.ALL]: { isActive: true },
  [TIMELINE_FILTERS.SYSTEM_INFO]: { isActive: false },
  [TIMELINE_FILTERS.EMAILS]: { isActive: false },
  [TIMELINE_FILTERS.COMMENTS]: { isActive: false },
  [TIMELINE_FILTERS.ACTIONS]: { isActive: false },
})
const filtersArray = Object.keys(filters.value)
const allFiltersFalse = () =>
  Object.keys(filters.value).every((key) => !filters.value[key].isActive)

const toggleFilter = (filter: string) => {
  $tracking?.event('Leads', 'Clicked', filter)

  if (filter === TIMELINE_FILTERS.ALL) {
    Object.keys(filters.value).forEach((key) => {
      filters.value[key].isActive = false
    })
    filters.value[TIMELINE_FILTERS.ALL].isActive = true
  } else {
    filters.value[TIMELINE_FILTERS.ALL].isActive = false
    filters.value[filter].isActive = !filters.value[filter].isActive
  }
  if (allFiltersFalse()) {
    filters.value[TIMELINE_FILTERS.ALL].isActive = true
  }
  emit('filter-change', filters.value)
}

const emit = defineEmits(['filter-change'])
</script>
